<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import Complex from './functions/complexClass';
	import fractionBuilder from './functions/fractionBuilder';
	import brackets from './functions/brackets';
	import Fraction from './functions/fractionClass';
	import polyBuilder from './functions/polyBuilder';
	import Surd from './functions/surdClass';

	export let uqn: number;
	export let qnNameCode = 0; // generate qn labels (a), (b), (c), etc

	let t: number;
	$: if (uqn<1000000){
		t = Number(uqn.toString()[0]);
	} else{
		t = 5;
	}
	let qn: string;
	$: qn = uqnToAns(uqn,t);

	function uqnToAns(u:number,t:number):string{
		if (t==1){ // powers of i
			return type1Generator(u);
		} else if (t<4){ // multiply/divide
			return type23Generator(u,t);
		} else if (t==4){ 
			return type4Generator(u);
		} else if (t==6){ 
			return type6Generator(u);
		} else{
			return type5Generator(u);
		}
	}

	function type1Generator(u:number):string{
		const n = Number(u.toString().slice(1));
		const z = new Complex(0,1);
		return z.pow(n).toString();
	}

	function type23Generator(u:number,t:number):string{
		let a: number, b:number, c:number, d:number, sign:number, _;
		[_, a,b,c,d,sign] = uqnSplit(u);
		switch (sign){
			case 1:
				d *= -1;
				break;
			case 2:
				c *= -1;
				break;
			case 3:
				b *= -1;
				break;
			case 4:
				a *= -1;
				break;
			case 5:
				c *= -1; d *= -1;
				break
			case 6:
				b *= -1; d *= -1;
				break
			case 7:
				a *= -1; d *= -1;
				break
			case 8:
				c *= -1; b *= -1;
				break
			case 9:
				c *= -1; a *= -1;
				break
		}
		let z = new Complex(a,b);
		let w = new Complex(c,d);
		let ansComplex: Complex;
		if (t==2){ //multiply
			ansComplex = z.multiply(w);
		} else{ // divide
			ansComplex = z.divide(w);
		}
		return ansComplex.toString();
	}

	function type5Generator(u:number):string{
		let a: number, b:number, c:number, d:number, e:number, f:number, sign:number, _;
		[b,a,c,d,e,f,sign] = uqnSplit(u);
		switch (sign){
			case 1:
				d *= -1;
				break;
			case 2:
				c *= -1;
				break;
			case 3:
				b *= -1;
				break;
			case 4:
				a *= -1;
				break;
			case 5:
				f *= -1;
				break
			case 6:
				e *= -1;
				break
			case 7:
				b *= -1; d *= -1;
				break
			case 8:
				a *= -1; f *= -1;
				break
			case 9:
				b *= -1; c *= -1;
				break
		}
		let w1 = new Complex(a,b);
		let w2 = new Complex(c,d);
		let w3 = new Complex(e,f);
		let wAns = w3.minus(w2).divide(w1);
		return "z="+wAns.toString();
	}

	function type4Generator(u:number):string{
		let a: number, b:number, sign:number, n:number, _;
		[_, a,b,sign,n] = uqnSplit(u);
		if (sign%2==1){
			b *= -1;
		};
		if (sign>1){
			a *= -1;
		}
		const z = new Complex(a,b);
		return z.pow(n).toString();
	}

	function type6Generator(u:number):string{
		let a: number, b:number, c:number, sign:number, _;
		[_, a,b,c,sign] = uqnSplit(u);
		if (sign==1){
			b *= -1;
		};
		let surd = new Surd(new Fraction(1,2*a),4*a*c-b*b);
		let minusB = new Fraction(-b,2*a);
		let minusBString = minusB.toString();
		if (b==0){
			minusBString = "";
		}
		return "z=" + minusBString + "\\pm" + surd.toString() + "i";
	}
	
</script>

<p> 
	({String.fromCharCode(qnNameCode+97)}) 
	<Katex math={qn}/>
</p>